const positionPopOver = (nudgeTop: number = 16, nudgeLeft: number = 12) => {
  return popoverState => {
    const { childRect, parentRect } = popoverState;
    return {
      top: childRect.top - parentRect.top - nudgeTop,
      left: childRect.left + childRect.width + nudgeLeft
    };
  };
};

export default positionPopOver;
